import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import RouterService from '@ember/routing/router-service';

export default class SettingsGroupsBaseController extends Controller {
  @service declare router: RouterService;

  @action
  goToListPage() {
    this.router.transitionTo('settings.groups.list');
  }
}
